module.exports = __webpack_public_path__ + "static/media/type.0b487a58.svg";